import { render } from "./CurrentAffairsFree.vue?vue&type=template&id=937a92a2&scoped=true"
import script from "./CurrentAffairsFree.vue?vue&type=script&lang=js"
export * from "./CurrentAffairsFree.vue?vue&type=script&lang=js"

import "./CurrentAffairsFree.vue?vue&type=style&index=0&id=937a92a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937a92a2"]])

export default __exports__